<template>
    <div>
        <div
            class="flex items-center gap-3 px-3 py-2 rounded-lg text-white"
            style="background-color: hsla(0, 0%, 100%, 0.1);"
            data-toggle="dropdown"
            aria-haspopup="true"
            @click="openModal = true"
            aria-expanded="false"
        >
            <div id="navbar-language">
                <img
                    :src="$t('images.lang-img')"
                    alt=""
                    class="mr-2"
                    style="width: 25px; height: 25px"
                />
            </div>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
            >
                <path
                    fill="currentColor"
                    d="m12 15.4l-6-6L7.4 8l4.6 4.6L16.6 8L18 9.4z"
                />
            </svg>
        </div>
        <ChangeLanguageModal
            :visible="openModal"
            @close="openModal = false"
        />
    </div>
</template>

<script>
import ChangeLanguageModal from './setting/ChangeLanguageModal.vue';

export default {
    components: {
        ChangeLanguageModal
    },
    data() {
        return {
            openModal: false
        }
    },
    methods: {
    }
}
</script>